// Source: frontend/src/shared/helpers/emailValidator.ts in member_webapp-frontend
const emailValidityRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;

const isEmailValid = (email: unknown): email is string =>
  !!email && typeof email === 'string' && emailValidityRegex.test(email);

export default isEmailValid;
